<template>
    <div>
        <div class="clear"></div>
        <div class="col-sm-2">{{ dateShort }}</div>
        <div :name="name" class="col-sm-2 timecard">
            <div class="col-xs-6">
                <time-input class="form-control" :name="dateObject.date + '_time_1'" type="text" v-model:time="time_1" :errors="timeErrors.time_1" :date-full="dateFull" @update="updateTime('time_1', $event)" :tzoffset="tzoffset"/>
            </div>
            <div class="col-xs-6">
                <time-input class="form-control" :name="dateObject.date + '_time_2'" type="text" v-model:time="time_2" :errors="timeErrors.time_2" :date-full="dateFull" @update="updateTime('time_2', $event)" :tzoffset="tzoffset"/>
            </div>
        </div>
        <div :name="name" class="col-sm-4">
            <div class="col-xs-3">
                <input class="bigger" :name="dateObject.date + '_shooting_day'" type="checkbox" v-model="union_on_prod" @change="updateOption('shooting_day', $event)"/>
            </div>
            <div class="col-xs-3">
                <input class="bigger" :name="dateObject.date + '_ndb'" type="checkbox" v-model="union_ndb" @change="updateOption('non_ded_breakfast', $event)"/>
            </div>
            <div class="col-xs-3">
                <input class="bigger" :name="dateObject.date + '_grace'" type="checkbox" v-model="union_grace" @change="updateOption('grace', $event)" :disabled="union_on_prod===false"/>
            </div>
            <div class="col-xs-3">
                <input class="bigger" :name="dateObject.date + '_wrap'" type="checkbox" v-model="union_wrap" @change="updateOption('wrap', $event)" :disabled="union_on_prod===false"/>
            </div>
        </div>
        <div :name="name" class="col-sm-4 timecard">
            <div class="col-xs-3">
                <time-input class="form-control" :name="dateObject.date + '_time_3'" type="text" v-model:time="time_3" :errors="timeErrors.time_3" :date-full="dateFull" @update="updateTime('time_3', $event)" :tzoffset="tzoffset" placeholder="Start" />
            </div>
            <div class="col-xs-3">
                <time-input class="form-control" :name="dateObject.date + '_time_4'" type="text" v-model:time="time_4" :errors="timeErrors.time_4" :date-full="dateFull" @update="updateTime('time_4', $event)" :tzoffset="tzoffset" placeholder="End" />
            </div>
            <div class="col-xs-3">
                <time-input class="form-control" :name="dateObject.date + '_time_5'" type="text" v-model:time="time_5" :errors="timeErrors.time_5" :date-full="dateFull" @update="updateTime('time_5', $event)" :tzoffset="tzoffset" placeholder="Start" />
            </div>
            <div class="col-xs-3">
                <time-input class="form-control" :name="dateObject.date + '_time_6'" type="text" v-model:time="time_6" :errors="timeErrors.time_6" :date-full="dateFull" @update="updateTime('time_6', $event)" :tzoffset="tzoffset" placeholder="End" />
            </div>
        </div>
        <div class="clear"></div>
    </div>
</template>

<script>
import timeInput from '../components/timeInput.vue';
import TimecardMixin from '../mixins/TimecardMixin';
import {defineComponent} from 'vue';

export default defineComponent ({
    emits: ['updateTime', 'updateOption', 'error'],
    props: {
        name: {
            type: String || Number,
            required: false
        },
        entityId: {
            type: Number,
            required: true
        },
        dateObject: {
            type: Object,
            required: true
        },
        tzoffset: {
            type: Number,
            required: false
        },
    },

    components: {
        timeInput
    },

    mixins: [ TimecardMixin ],

    data() {
        return {
            locale: ( window.navigator.languages && window.navigator.languages.length ? window.navigator.languages[0] : window.navigator.language) || 'en-US',
            time_1: null,
            time_3: null,
            time_4: null,
            time_5: null,
            time_6: null,
            time_2: null,
            union_on_prod: false,
            union_ndb: false,
            union_grace: false,
            union_wrap: false,
            timeErrors: {
                time_1: false,
                time_2: false,
                time_3: false,
                time_4: false,
                time_5: false,
                time_6: false,
            },
        }
    },

    computed: {
        dateFull () {
            const date = this.dateObject.date;
            const Y = date.substr(0,4);
            const m = date.substr(4,2);
            const d = date.substr(6,2);
            return new Date(Y + '-' + m + '-' + d + ' 10:00:00');
        },
        dateShort () {
            if (this.locale === 'en-CA') {
                return this.dateFull.toLocaleDateString('en-GB', {
                weekday: 'short',
                day: '2-digit',
                month: '2-digit',
            });
            } else {
                return this.dateFull.toLocaleDateString(this.locale, {
                weekday: 'short',
                day: '2-digit',
                month: '2-digit',
            });
            }
        },
    },

    methods: {
        updateTime (field, event) {
            // console.log(field + ': ' + event.value);
            this.$emit('updateTime', { name: field, value: event.value, date: this.dateObject.date });
            this.verifyDate(event);
            return true;
        },

        updateOption (field, { target }) {
            this.$emit('updateOption', { name: field, value: target.checked, date: this.dateObject.date });
        },

        verifyDate (target) {
            if (! target) {
                return false;
            }

            // console.log('VerifyDate');
            // console.log(target)
            let error = ' '; // messages if needed

            // Don't check if time out is not done
            if ((this.time_1 || this.time_3 || this.time_4 || this.time_5 || this.time_6) && (this.time_2)) { this.timeErrors.time_2 = true; }
            else if ((this.time_2 || this.time_3 || this.time_4 || this.time_5 || this.time_6) && (this.time_1)) { this.timeErrors.time_1 = true; }

            // Check if field pairs are complete
            if (this.time_2 && ! this.time_1) { this.timeErrors.time_1 = true; error += ' Please enter a start time.';
            } else if (this.time_1 && ! this.time_2) { this.timeErrors.time_2 = true; }
            else { this.timeErrors.time_1 = false; this.timeErrors.time_2 = false; }

            if (this.time_3 && ! this.time_4) { this.timeErrors.time_4 = true;
            } else if (this.time_4 && ! this.time_3) { this.timeErrors.time_3 = true; error += ' Please enter a meal 1 beginning time.'; }
            else { this.timeErrors.time_3 = false; this.timeErrors.time_4 = false; }

            if (this.time_5 && ! this.time_6) { this.timeErrors.time_6 = true;
            } else if (this.time_6 && ! this.time_5) { this.timeErrors.time_5 = true; error += ' Please enter a meal 2 beginning time.'; }
            else { this.timeErrors.time_5 = false; this.timeErrors.time_6 = false; }

            if (this.time_5 && ! this.time_3) { this.timeErrors.time_3 = true; error += ' Please enter a first meal before a second meal.';
            } else { this.timeErrors.time_5 = false; this.timeErrors.time_3 = false; }

            // Now check if times are greater
            if (this.time_2 && this.time_1 && this.time_2 < this.time_1) {
                this.timeErrors.time_1 = true; this.timeErrors.time_2 = true;
                error += ' Your wrap (out) time is earlier than your call (in) time.<br />Make sure to use military or "p" to designate evening hours, e.g. 6:30pm = 1830 or 630p.<br />If you worked overnight, you will have to add 24 hours to your call time, e.g. 5:30am would be 2930 (24 + 5:30).';
            }
            if (this.time_4 && this.time_3 && this.time_4 < this.time_3) {
                this.timeErrors.time_3 = true; this.timeErrors.time_4 = true; error += ' Please make sure your 1st meal end is later than your meal start.';
            }
            if (this.time_6 && this.time_5 && this.time_6 < this.time_5) {
                this.timeErrors.time_5 = true; this.timeErrors.time_6 = true; error += ' Please make sure your 2nd meal end is later than your meal start.';
            }

            // Check meal times are in the right sequence   
            if (this.time_4 && this.time_2 < this.time_4) {
                this.timeErrors.time_4 = true; this.timeErrors.time_2 = true; error += ' Your meal should be earlier than your wrap (out) time.'; 
            }
            if (this.time_3 && this.time_3 < this.time_1) {
                this.timeErrors.time_1 = true; this.timeErrors.time_3 = true; error += ' Your meal should be later than your call (in) time.'; 
            }
            if (this.time_5 && this.time_5 < this.time_4) {
                this.timeErrors.time_4 = true; this.timeErrors.time_5 = true; error += ' Your 2nd meal should be later than your 1st meal time.'; 
            }

            this.$emit('error', error)
            return true;
        },

        closeModal() { this.showDetails = false; },

        closeDetails() {
            this.showDetails = false;
        }
    },

    created() {
    },

    mounted() {
        if (this.dateObject.time_1) {
            this.call_time = this.dateObject.time_1 || null;
            this.time_1 = this.dateObject.time_1 ? this.shortenDate(this.dateObject.time_1, null, this.dateObject.date.full) : "";
        }
        if (this.dateObject.time_2) {
            this.wrap_time = this.dateObject.time_2 || null;
            this.time_2 = this.dateObject.time_2 ? this.shortenDate(this.dateObject.time_2, this.dateObject.time_1,this.dateObject.date.full) : "";
        }
        if (this.dateObject.time_3) {
            this.meal1_time_start = this.dateObject.time_3 || null;
            this.time_3 = this.dateObject.time_3 ? this.shortenDate(this.dateObject.time_3, this.dateObject.time_1,this.dateObject.date.full) : "";
        }
        if (this.dateObject.time_4) {
            this.meal1_time_end = this.dateObject.time_4 || null;
            this.time_4 = this.dateObject.time_4 ? this.shortenDate(this.dateObject.time_4, this.dateObject.time_1,this.dateObject.date.full) : "";
        }
        if (this.dateObject.time_5) {
            this.meal2_time_start = this.dateObject.time_5 || null;
            this.time_5 = this.dateObject.time_5 ? this.shortenDate(this.dateObject.time_5, this.dateObject.time_1,this.dateObject.date.full) : "";
        }
        if (this.dateObject.time_6) {
            this.meal2_time_end = this.dateObject.time_6 || null;
            this.time_6 = this.dateObject.time_6 ? this.shortenDate(this.dateObject.time_6, this.dateObject.time_1,this.dateObject.date.full) : "";
        }
        this.union_on_prod = this.dateObject.shooting_day == 1 ? true : false;
        this.union_ndb = this.dateObject.non_ded_breakfast == 1 ? true : false;
        this.union_grace = this.dateObject.grace == 1 ? true : false;
        this.union_wrap = this.dateObject.wrap == 1 ? true : false;
    }
});
</script>
<style scoped>
    .checkbox-skinny{ margin: 70% 0px 0px 40% }
    .checkbox-border{ border: 1px solid #cccccc; border-radius: 4px; height: 34px; }
    .space-left{ padding-left: 2px !important;}
    .space-right{ padding-right: 2px !important;}
</style>